import { IAddress } from '@/shared/model/address.model';
import { IMarketer, Marketer } from '@/shared/model/marketer.model';
import { IRestaurant } from '@/shared/model/restaurant.model';
import { IUser } from '@/shared/model/user.model';
import { MutationTree } from 'vuex';
import { IMarketerStore } from './types';

export const mutations: MutationTree<IMarketerStore> = {
  setMarketer(state, newMarketer: IMarketer): void {
    newMarketer.moderator = newMarketer.moderator ?? new Marketer();
    state.marketer = newMarketer;
  },
  setId(state, newId: number): void {
    state.marketer.id = newId;
  },
  setBankAccountName(state, newBankAccountName: string): void {
    state.marketer.bankAccountName = newBankAccountName;
  },
  setIbanNumber(state, newIbanNumber: string): void {
    state.marketer.ibanNumber = newIbanNumber;
  },
  setCocRegistration(state, newCocRegistration: string): void {
    state.marketer.cocRegistration = newCocRegistration;
  },
  setCocRegistrationContentType(state, newCocRegistrationContentType: string): void {
    state.marketer.cocRegistrationContentType = newCocRegistrationContentType;
  },
  setUser(state, newUser: IUser): void {
    state.marketer.user = newUser;
  },
  setAddress(state, newAddress: IAddress): void {
    state.marketer.address = newAddress;
  },
  setMarketers(state, newMarketers: IMarketer[]): void {
    state.marketer.marketers = newMarketers;
  },
  setRestaurants(state, newRestaurants: IRestaurant[]): void {
    state.marketer.restaurants = newRestaurants;
  },
  setModerator(state, newModerator: IMarketer): void {
    state.marketer.moderator = newModerator;
  },
  setTab(state, newTab: string): void {
    state.tab = newTab;
  },
  setDrawer(state, newDrawer: boolean): void {
    state.drawer = newDrawer;
  },
  businessCardSimulator(state): void {
    state.businessCardSimulator = !state.businessCardSimulator;
  },
};
